import * as React from "react";

import { PBXIcon } from "./styled";
import SelectRow from "./SelectRow";

const PbxRow = ({
  pbxOptions,
  selectedPbx,
  setSelectedPbx,
  menuPortalTarget,
  selectorTestId,
}) => {
  const onPbxChange = React.useCallback(
    (option) => {
      if (setSelectedPbx) {
        setSelectedPbx(option);
      }
    },
    [setSelectedPbx]
  );

  return (
    <SelectRow
      renderIcon={() => <PBXIcon />}
      labelText="PBX:"
      options={pbxOptions}
      currentSelection={selectedPbx}
      onSelectionChange={onPbxChange}
      placeholderText="No PBX(s)."
      menuPortalTarget={menuPortalTarget}
      getValueToCopy={(option) => option?.label}
      selectorTestId={selectorTestId ?? "pbx-select-row"}
    />
  );
};

export default PbxRow;
